'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-1887e1af.js');
var React = require('react');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var StepperContainer = styled__default["default"].div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"])));
var StepContainer = styled__default["default"].div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  flex-grow: ", ";\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  flex-grow: ", ";\n"])), function (_a) {
    var is_last_step = _a.is_last_step;
    return (is_last_step ? '0' : '2');
});
var LineContainer = styled__default["default"].div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  flex-grow: 2;\n"], ["\n  display: flex;\n  justify-content: center;\n  flex-grow: 2;\n"])));
var Line = styled__default["default"].div(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  margin-top: 10px;\n  height: 1px;\n  max-width: 200px;\n  min-width: 50px;\n  flex-grow: 2;\n  background-color: ", ";\n"], ["\n  margin-top: 10px;\n  height: 1px;\n  max-width: 200px;\n  min-width: 50px;\n  flex-grow: 2;\n  background-color: ", ";\n"])), function (_a) {
    var primary = _a.theme.colors.border.primary;
    return primary;
});
var Stepper = function (_a) {
    var children = _a.children, className = _a.className;
    return (React__default["default"].createElement(StepperContainer, { className: className }, React__default["default"].Children.toArray(children).map(function (child, index) { return (React__default["default"].createElement(StepContainer, { key: index, is_last_step: index === React__default["default"].Children.toArray(children).length - 1 },
        child,
        index !== React__default["default"].Children.toArray(children).length - 1 && (React__default["default"].createElement(LineContainer, null,
            React__default["default"].createElement(Line, null),
            ' ')))); })));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

exports["default"] = Stepper;
